import React from 'react';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogActions from '@material-ui/core/DialogActions';
import Button from '@material-ui/core/Button';
import { useTranslation } from 'react-i18next';

interface IProps {
  open: boolean;
  handleClose: () => void;
}

const BusinessCustomerVerificationDialog: React.FC<IProps> = (props) => {
  const {t} = useTranslation();
  const { open, handleClose } = props;
  return (
    <Dialog open={open} onClose={handleClose}>
      <DialogTitle>
        {t("root:accountVerification")}
      </DialogTitle>
      <DialogContent>
        <DialogContentText>
          {t("root:profileNotVerifiedMessage")}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} color="primary">
          {t("misc:close")}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default BusinessCustomerVerificationDialog;
